import { useEffect, useRef } from 'react';

export default function useNoteDrawerPlayback(open) {
    const playbackBeforeOpen = useRef(null);

    useEffect(() => {
        const audio = document.getElementById('audio');
        if (open) {
            playbackBeforeOpen.current = audio ? {
                audio,
                source: audio.src,
                shouldResume: !audio.paused && !audio.ended,
            } : null;
            audio?.pause();
            return;
        }

        const playback = playbackBeforeOpen.current;
        playbackBeforeOpen.current = null;
        if (
            playback?.shouldResume &&
            playback.audio === audio &&
            playback.source &&
            audio.src === playback.source &&
            audio.paused &&
            !audio.ended
        ) {
            audio.play().catch(() => {
                // Navigation can interrupt playback, or the browser can block it.
            });
        }
    }, [open]);
}
